import React from 'react';
import { bonusTotal, bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-cream-200 px-4 py-16" data-id="element-25" data-mp="pkhf8179tmgj">
      <div className="mx-auto max-w-3xl" data-id="element-26" data-mp="pm2ajt1et9fg">
        <div className="text-center" data-id="element-27" data-mp="avlcmjnzh1nb">
          <h2 className="font-display text-[28px] font-black leading-tight tracking-[-0.01em] text-ink sm:text-[34px]" data-id="element-28" data-mp="aujxo43ujv0b">
            <span aria-hidden="true" data-id="element-29" data-mp="fs3ffdzr6px0">🎁</span> 5 Bonus Esclusivi
          </h2>
          <p className="mt-2 font-sans text-[14px] text-ink-soft" data-id="element-30" data-mp="1stzmffglxtk">
            Valore totale{' '}
            <span className="font-bold text-brand line-through" data-id="element-31" data-mp="5xjq1orcmk73">{bonusTotal}</span> — Inclusi
            oggi <span className="font-bold text-brand" data-id="element-32" data-mp="3o369yhbo54hb">GRATIS</span> nel prezzo
          </p>
        </div>

        <ol className="mt-8 space-y-4" data-id="element-33" data-mp="3t0yc046126z8">
          {bonuses.map((bonus, i) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white px-5 py-6 sm:gap-6 sm:px-8" data-id="element-34" data-mp="1mbjqr1y0qdve" data-mpi={i}>
              <span aria-hidden="true" className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-sans text-[12px] font-bold text-white" data-id="element-35" data-mp="3ie6j3kp847x9">
                {i + 1}
              </span>

              <img src={bonus.image} alt="" className="h-[130px] w-[100px] shrink-0 object-contain" width={100} height={130} data-id="element-36" data-mp="3r5ykz706m8q8" />

              <div className="min-w-0" data-id="element-37" data-mp="2zhez191uxos5">
                <h3 className="font-display text-[15px] font-bold leading-snug text-ink" data-id="element-38" data-mp="2uhixdggmu9fr">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-sans text-[12.5px] leading-relaxed text-ink-soft" data-id="element-39" data-mp="38e5v3lget3mq">
                  {bonus.text}
                </p>
                <p className="mt-2 font-sans text-[12px] font-bold" data-id="element-40" data-mp="np8d0ml1hllw">
                  <span className="text-brand line-through" data-id="element-41" data-mp="iqyhgavekizr">{bonus.value}</span>{' '}
                  <span className="text-brand-dark" data-id="element-42" data-mp="it14cm19dw09">GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}